import { mapColors } from 'app/containers/Map/slice/map-constants';
import styled from 'styled-components';

export const CultureCircle = styled.div<{ $color?: string }>`
  width: 24px;
  background: ${p => p.$color || mapColors.colors.DEFAULT};
  height: 24px;
  border-radius: 100%;
  display: flex;
  svg {
    margin: auto;
  }
`;
